module.exports = __webpack_public_path__ + "static/media/youhuiquan-icon.932aa103.svg";